export default {
  // Page title and subtitle
  'page.mainTitle': 'Unix Timestamp Converter',
  'page.mainTitleSEO': 'Unix Timestamp Converter & Epoch Time Tool',
  'page.subtitle': 'Convert Unix timestamp to datetime and datetime to timestamp instantly',
  'page.title': 'Timestamp Converter',
  'page.currentTimestamp': 'Current Unix Timestamp',
  'page.currentEpochTime': 'Current Unix Epoch Time',
  'page.milliseconds': 'Milliseconds (13 digits)',
  'page.seconds': 'Seconds (10 digits)',
  'page.millisecondsOnly': 'Milliseconds',
  'page.secondsOnly': 'Seconds',
  'page.currentDateTime': 'Current Date & Time',

  // Interactive Converter
  'page.interactiveConverter': 'Interactive Timestamp ↔ Date Converter',
  'page.timestampToDatetimeTitle': 'Unix Timestamp to Datetime',
  'page.datetimeToTimestampTitle': 'Datetime to Timestamp',
  'page.ms': 'MS',
  'page.sec': 'SEC',
  'page.autoDetect': 'Auto-detect format',
  'page.detected': 'Detected',
  'page.digits': 'digits',
  'page.convertedTo': 'Converted to',
  'page.converterTip': 'Real-time Bidirectional Conversion',
  'page.converterTipDesc': 'Type in either field to instantly see the conversion. Automatically detects 10-digit (seconds) or 13-digit (milliseconds) timestamps.',

  // Conversion sections
  'page.timestampToDateTime': 'Timestamp to Date Time',
  'page.dateTimeToTimestamp': 'Date Time to Timestamp',
  'page.selectFormat': 'Select Format',
  'page.enterTimestamp': 'Enter timestamp',
  'page.enterDateTime': 'Select date and time',
  'page.convertedResult': 'Converted Result',
  'page.yourTimeZone': 'Your Time Zone',
  'page.relative': 'Relative',

  // Relative time translations
  'page.relativeTime.secondsAgo': '{{seconds}} seconds ago',
  'page.relativeTime.minutesAgo': '{{minutes}} minutes ago',
  'page.relativeTime.hoursAgo': '{{hours}} hours ago',
  'page.relativeTime.daysAgo': '{{days}} days ago',
  'page.relativeTime.inSeconds': 'in {{seconds}} seconds',
  'page.relativeTime.inMinutes': 'in {{minutes}} minutes',
  'page.relativeTime.inHours': 'in {{hours}} hours',
  'page.relativeTime.inDays': 'in {{days}} days',

  // What is Timestamp section (FAQ)
  'page.faq': 'Frequently Asked Questions (FAQ)',
  'page.whatIsTimestamp': 'What is a Unix Timestamp?',
  'page.timestampIntro': 'A Unix timestamp (also known as Epoch time or POSIX time) is a system for describing a point in time as the number of seconds (or milliseconds) that have elapsed since 00:00:00 UTC on January 1, 1970 (the Unix epoch), not counting leap seconds. This standard is widely used in computing and programming as a simple, universal way to represent dates and times.',

  'page.unixEpochTitle': 'Unix Epoch - The Beginning of Time',
  'page.unixEpochDesc': 'The Unix epoch is midnight UTC on January 1, 1970. All Unix timestamps are calculated from this specific moment in time, making it a universal reference point for computer systems worldwide.',

  'page.timestampFormatsTitle': 'Timestamp Formats',
  'page.secondsFormat': 'Seconds (10-digit)',
  'page.secondsFormatDesc': 'Standard Unix timestamp representing seconds since epoch. Example: 1734598784',
  'page.millisecondsFormat': 'Milliseconds (13-digit)',
  'page.millisecondsFormatDesc': 'Extended timestamp with millisecond precision. Example: 1734598784000',

  'page.whyUseTimestampTitle': 'Why do we use Unix Time?',
  'page.reason1Title': 'Time Zone Independent',
  'page.reason1Desc': 'Timestamps represent UTC time, eliminating time zone confusion in global applications.',
  'page.reason2Title': 'Easy Calculations',
  'page.reason2Desc': 'Simple arithmetic operations to calculate time differences and durations.',
  'page.reason3Title': 'Database Friendly',
  'page.reason3Desc': 'Compact integer storage format perfect for database indexing and sorting.',
  'page.reason4Title': 'Universal Standard',
  'page.reason4Desc': 'Supported by virtually all programming languages and platforms.',
  'page.year2038Problem': 'What happens in 2038? (The Year 2038 Problem)',
  'page.year2038Content': 'The Year 2038 problem (also known as Y2038 or Unix Millennium Bug) refers to the time when 32-bit Unix timestamps will overflow. On January 19, 2038, at 03:14:07 UTC, signed 32-bit integers will reach their maximum value (2,147,483,647) and wrap around to negative numbers. Modern systems using 64-bit timestamps are not affected and can represent dates billions of years into the future.',

  // Coding examples section
  'page.codingExamples': 'How to Get Current Timestamp in Different Programming Languages',
  'page.codeCheatSheet': 'Unix Timestamp Code Cheat Sheet (By Language)',
  'page.howToGetTimestamp': 'How to Get Current Timestamp',
  'page.convertToDate': 'Convert Timestamp to Date Object',
  'page.convertToTimestamp': 'Convert Date to Timestamp',
  'page.getCurrentTimestamp': 'Get Current Timestamp',
  'page.getMilliseconds': 'Get milliseconds timestamp',
  'page.getSeconds': 'Get seconds timestamp',

  // Timestamp to Date conversion examples
  'page.timestampToDateExamples': 'How to Convert Unix Timestamp to Date/Time',
  'page.timestampToDateDesc': 'Learn how to convert Unix timestamps to human-readable date and time formats in various programming languages. Whether you have seconds or milliseconds timestamps, these examples show you the proper conversion methods.',
  'page.convertTimestampToDate': 'Convert Timestamp to Date',
  'page.fromMilliseconds': 'From milliseconds timestamp',
  'page.fromSeconds': 'From seconds timestamp',
  'page.formatOptions': 'Format with custom options',
  'page.toUTC': 'Convert to UTC',
  'page.formatDate': 'Format the date',

  // Date to Timestamp conversion examples
  'page.dateToTimestampExamples': 'How to Convert Date/Time to Unix Timestamp',
  'page.dateToTimestampDesc': 'Learn how to convert dates and times to Unix timestamps in different programming languages. These examples demonstrate parsing date strings, creating timestamps from date components, and handling both seconds and milliseconds formats.',
  'page.convertDateToTimestamp': 'Convert Date to Timestamp',
  'page.fromDateString': 'From date string',
  'page.fromDateComponents': 'From date components',
  'page.parseString': 'Parse date string',
  'page.monthNote': 'Note: month is 0-indexed',
  'page.useCalendar': 'Using Calendar',
  'page.parseFormat': 'Parse with format',
  'page.fromComponents': 'From time components',
  'page.currentTime': 'Get current timestamp',
  'page.fromDatetime': 'From datetime column',

  // How to use
  'page.howToUse': 'How to Use This Timestamp Converter',
  'page.step1': '📊 Current Timestamp: View real-time Unix timestamp in both seconds (10 digits) and milliseconds (13 digits) format. Click copy button to quickly copy the timestamp to your clipboard.',
  'page.step2': '🔄 Timestamp to DateTime: Enter a Unix timestamp and select whether it\'s in seconds or milliseconds format. Click convert to see the corresponding date and time in multiple formats including GMT, your local time zone, ISO 8601, and relative time.',
  'page.step3': '📅 DateTime to Timestamp: Select any date and time using the date picker, or click "Now" to use current time. Convert to get both seconds and milliseconds timestamp formats instantly.',
  'page.step4': '💡 Quick Tips: Unix timestamp is the number of seconds/milliseconds since January 1, 1970 00:00:00 UTC. Use 10-digit format for seconds, 13-digit for milliseconds. All conversions are instant and work offline.',

  // Related Tools
  'page.relatedTools': 'Related Time Tools',
  'page.relatedToolsDesc': 'Explore our other professional time management tools',
  'page.timerTool': 'Online Timer',
  'page.timerToolDesc': 'Countdown timer perfect for Pomodoro technique, cooking, studying, and work breaks',
  'page.stopwatchTool': 'Stopwatch',
  'page.stopwatchToolDesc': 'High-precision stopwatch with millisecond accuracy for sports training and timing',
  'page.worldClockTool': 'World Clock',
  'page.worldClockToolDesc': 'Real-time world clock showing current time in major cities worldwide',

  // Specialized Tools
  'page.specializedTools': 'Specialized Timestamp Tools',
  'page.specializedToolsDesc': 'Explore specialized timestamp tools for different platforms and use cases',
  'page.discord.desc': 'Generate <t:format> codes with automatic timezone conversion for Discord events',
  'page.discord.topSearch': 'Top Search',
  'page.discord.searchesPerMonth': 'searches/mo',
  'page.youtube.desc': 'Create shareable YouTube links that start at specific times',
  'page.youtube.popular': 'Popular',

  // Programming Guides
  'page.programmingGuides': 'Programming Language Timestamp Guides',
  'page.programmingGuidesDesc': 'Learn timestamp handling methods, functions, and best practices for each programming language',
  'page.sql.desc': 'MySQL, PostgreSQL, Oracle, SQL Server timestamp handling',
  'page.sql.highPriority': 'High Priority',
  'page.sql.searches': 'searches',
  'page.python.desc': 'datetime, time, calendar modules guide',
  'page.python.popular': 'Popular',
  'page.javascript.desc': 'Date object, Day.js, date-fns library guide',
  'page.javascript.common': 'Common',
  'page.codeExamplesNote': 'Includes complete code examples, best practices, and FAQs',
};
